import { DEFAULT_ERROR_MESSAGE } from '../data-types/initialisation/initialisationConstants';
import { CountrySettingsResponse } from '../data-types/international/internationalInterfaces';
import { LocationResponse } from '../data-types/user/userInterfaces';
import { userSocketDetails } from '../socket-types/userScoketTypes';
import { sendCommand } from './commandsHandler';

export const getGeoLocationInfo = async () => {
  const res = await sendCommand<LocationResponse>(userSocketDetails, {});

  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res.data;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

export const getAllCountrySettings = async () => {
  const res = await sendCommand<CountrySettingsResponse>('international:allowedLoginsCountries', {});

  if (res.data) {
    return res.data;
  }

  if (res.error && res.error.message) {
    throw new Error(res.error.message);
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};
